import { fonts } from '~/src/helpers/font';
import { EElementType, ILandingElement } from '~/src/services/projects';

export const ImageSection: ILandingElement = {
    title: 'ImageSection',
    type: EElementType.ImageSection,
    label: 'Секция',
    children: [
        {
            title: 'Title',
            type: EElementType.RTE,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H1,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                htmlContent: 'Заголовок',
                customStyles: 'white-space: pre-wrap;',
            },
        },
        {
            title: 'SubTitle',
            type: EElementType.RTE,
            label: 'Подзаголовок',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#656565',
                    textAlign: 'left',
                },
                htmlContent: 'Подзаголовок',
                customStyles: '',
            },
        },
        {
            title: 'Text',
            type: EElementType.RTE,
            label: 'Описание',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#656565',
                    textAlign: 'left',
                },
                htmlContent: '<p>Текст...</p>',
                customStyles: '',
            },
        },
        {
            title: 'Image',
            type: EElementType.Image,
            label: 'Изображение',
            properties: {
                content: '',
                webp: '',
                alt: '',
                customStyles: '',
                customize: {
                    width: '648px',
                    height: '413px',
                },
            },
        },
    ],
};

export const Shift: ILandingElement = {
    title: 'Shift',
    type: EElementType.Block,
    label: 'Блок с картинками',
    properties: {
        blockName: '',
        customStyles: '',
        content: '',
        fixedImages: true,
        addElement: EElementType.ImageSection,
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        marginTop: '',
        marginBottom: '',
    },
    children: [
        ImageSection,
    ],
};
